import { render } from "./OtherRooms.vue?vue&type=template&id=83c1d3fe&scoped=true"
import script from "./OtherRooms.vue?vue&type=script&lang=js"
export * from "./OtherRooms.vue?vue&type=script&lang=js"

import "./OtherRooms.vue?vue&type=style&index=0&id=83c1d3fe&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c1d3fe"]])

export default __exports__